<template>
    <div>
        <b-sidebar
            v-model="open"
            title="Detalhes da Atividade"
            backdrop-variant="dark"
            width="425px"
            backdrop
            shadow
        >
            <div class="px-3 py-2" v-if="task">
                <dl>
                    <dt>
                        Atividade
                    </dt>
                    <dd>
                        {{ task.name }}
                    </dd>
                </dl>
                <dl v-if="task.group">
                    <dt>
                        Envios das Redações
                    </dt>
                    <dd>

                        <b-progress :value="task.essays.length" :max="task.group.students_count" variant="success" class="mb-1 mt-2"></b-progress>

                        <div class="text-dark">
                            <b>{{ task.group.students_count }}</b> aluno(s) participando e <b>{{ task.essays.length }}</b> atividade(s) enviadas
                        </div>

                        <div class="mt-1">
                            <b-button variant="outline-primary" size="sm" @click="detailStudents">
                                ver detalhes dos envios dos alunos
                            </b-button>
                        </div>

                    </dd>
                </dl>
                <dl>
                    <dt>
                        Desempenho da Turma
                    </dt>
                    <dd>
                        <div class="mt-1">
                            <b-button variant="outline-primary" size="sm" @click="detailResults">
                                ver resultados das correções da atividade
                            </b-button>
                        </div>
                    </dd>
                </dl>
                <dl>
                    <dt>
                        Exportar Resultados
                    </dt>
                    <dd>
                        <div class="mt-1">
                            <a :href="'/teacher/tasks/' + task.id + '/export'" target="_blank" class="btn btn-sm btn-outline-primary mr-3">
                                <i class="fas fa-file-export mr-1"></i>
                                Exportar em Planilha
                            </a>
                        </div>
                    </dd>
                </dl>
                <dl v-if="task.documents.length > 0">
                    <dt>
                        Material Complementar
                    </dt>
                    <dd>
                        <div v-for="item in task.documents" :key="item.id">
                            <a :href="item.preview" target="_blank" class="text-info">
                                <i class="fas fa-file mr-1"></i>
                                {{ item.name }}
                            </a>
                        </div>
                    </dd>
                </dl>
                <dl>
                    <dt>
                        Corretor
                    </dt>
                    <dd>
                        <span v-if="task.teacher">
                            {{ task.teacher.name }}
                        </span>
                        <span v-else>
                            ---
                        </span>
                    </dd>
                </dl>
                <dl>
                    <dt>
                        Turma
                    </dt>
                    <dd>
                        <span v-if="task.group">
                            {{ task.group.name }}
                        </span>
                        <span v-else>
                            ---
                        </span>
                    </dd>
                </dl>
                <dl>
                    <dt>
                        Modo de Correção / Tema
                    </dt>
                    <dd>
                        <span v-if="task.theme">
                            <a :href="'/teacher/themes/' + task.theme.id" target="_blank">
                                {{ task.theme.title }}
                            </a>
                        </span>
                        <span v-else>
                            <span v-if="task.mode">
                                {{ task.mode.name }}
                            </span>
                            <span v-else>
                                ---
                            </span>
                        </span>
                    </dd>
                </dl>
                <dl>
                    <dt>
                        Data Início
                    </dt>
                    <dd>
                        {{ task.from | moment('DD/MM/YYYY HH:mm') }}
                    </dd>
                </dl>
                <dl>
                    <dt>
                        Data Fim
                    </dt>
                    <dd v-if="task.to">
                        {{ task.to | moment('DD/MM/YYYY HH:mm') }}
                    </dd>
                    <dd v-else>
                        ---
                    </dd>
                </dl>
                <dl>
                    <dt>
                        Status
                    </dt>
                    <dd>
                        <span v-if="task.status === 'waiting'" class="text-info">
                            Aguardando Início
                        </span>

                        <span v-else-if="task.status === 'in_progress'" class="text-primary">
                            Em Andamento
                        </span>

                        <span v-else-if="task.status === 'finished'" class="text-success">
                            Finalizada
                        </span>

                        <span v-else>
                            ---
                        </span>
                    </dd>
                </dl>
                <dl>
                    <dt>
                        Criada
                    </dt>
                    <dd>
                        {{ task.created_at | moment('from', 'now') }}
                    </dd>
                </dl>
                <dl>
                    <dt>
                        Última Modificação
                    </dt>
                    <dd>
                        {{ task.updated_at | moment('from', 'now') }}
                    </dd>
                </dl>
            </div>

            <template #footer v-if="task">
                <div class="d-flex bg-light text-dark align-items-center border-top px-3 py-2">

                    <div class="mr-auto">

                        <a href="#" class="mr-3" v-b-tooltip.hover title="Editar Atividade" @click="editTask">
                            <i class="fas fa-pencil-alt mr-1"></i> Editar
                        </a>

                        <a href="#" class=" text-danger" v-b-tooltip.hover title="Excluir Atividade" @click="destroyTask">
                            <i class="fas fa-trash-alt mr-1"></i> Excluir
                        </a>

                    </div>

                    <div class="ml-auto">

                    </div>

                </div>
            </template>

        </b-sidebar>

        <!-- Destroy -->
        <destroy></destroy>

        <!-- Students -->
        <students></students>

        <!-- Results -->
        <results></results>

    </div>
</template>

<script>
import Destroy from "./Destroy";
import Students from "./Students";
import Results from "./Results";

export default {
    components: {
        Destroy,
        Students,
        Results
    },
    props: [],
    data() {
        return {
            open: false,
            task: null
        }
    },
    created() {

        this.$root.$on('tasksShowDetail', (task) => {
            this.task = task
            this.open = true
        })

    },
    methods: {

        editTask() {
            window.location = '/teacher/tasks/' + this.task.id + '/edit'
        },

        destroyTask() {
            this.$root.$emit('destroyTask', this.task)
        },

        detailStudents() {
            this.$root.$emit('studentsTask', this.task)
        },

        detailResults() {
            this.$root.$emit('resultsTask', this.task)
        },

    }
}
</script>

<style scoped>

</style>
